import { FiHome } from 'react-icons/fi';
import { MdKeyboardArrowRight } from 'react-icons/md';
import './breadcrumb.style.scss';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import React from 'react';

const BreadCrumb = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="breadcrumb">
      <div className="home_icon">
        <FiHome />
      </div>

      {pathname
        .split('/')
        .filter(item => item)
        .slice(0, 2)
        .map((item, index) => {
          return (
            <React.Fragment key={item}>
              <div className="arrow_icon">
                <MdKeyboardArrowRight />
              </div>

              <p
                onClick={() => index === 0 && navigate(`/${item}`)}
                style={{
                  cursor: index === 0 ? 'pointer' : 'initial',
                }}
              >
                {item.replace('-', ' ')}
              </p>
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default BreadCrumb;
